import ArrowDownSVG from "../../../../svgs/ArrowDownSVG";
import MoriButton from "../../../../Components/systemDesign/Buttons/MoriButton";
import ArrowBackSVG from "../../../../svgs/ArrowBackSVG";
import ChatbotLogoSVG from "../../../../svgs/ChatbotLogoSVG";
import { Link } from "react-router-dom";

const LeftSide = () => {
  return (
    <div className="w-[40%] h-full pl-[150px] pt-10 pr-24 text-text5">
      <div className="absolute top-32 left-44 bg-clip-border border-[#0F0F0F] text-[110px] font-semibold specialtext opacity-10 [&>h2]:-mb-12">
        <h2>IR .</h2>
        <h2>Ai Chatbot</h2>
        <h2>Lawyer</h2>
      </div>
      <div className="relative z-10 flex flex-col gap-5">
        <div>
          <Link to="/landing" className="text-[15px] flex gap-2 items-center">
            <ArrowBackSVG /> Back to home
          </Link>
        </div>
        <div className="flex gap-2 items-center mt-10 text-[17px]">
          <ChatbotLogoSVG />
          ai-chatbot/lawyer
        </div>
        <div className="flex flex-col -mb-10">
          <h2 className="text-transparent bg-clip-text bg-gradient-to-r from-[#4285F4] to-[#9B72CB] text-[70px] font-semibold">
            IR . Ai Chatbot
          </h2>
          <h2 className="text-transparent bg-clip-text bg-gradient-to-r from-[#4285F4] to-[#9B72CB] text-[70px] font-semibold relative bottom-10">
            Lawyer
          </h2>
        </div>
        <div className="text-[20px]">
          <h3>A full-featured, hackable Next.js AI chatbot built by</h3>
          <h3>Vercel</h3>
        </div>
        <div className="flex justify-between items-center pr-4 gap-6 [&>button]:!w-1/2">
          <MoriButton
            text="Start Chat"
            textCustomClass="!text-[16px] !text-[#0A0A0A]"
            customClass="!bg-subColor5 !opacity-100 border-[1px] border-stroke1 !h-[48px] !rounded-lg cursor-pointer"
          />
          <MoriButton
            text="About Us"
            textCustomClass="!text-[16px] !text-subColor5"
            customClass="!bg-[#0A0A0A] !opacity-100 border-[1px] border-stroke1 !h-[48px] !rounded-lg cursor-pointer"
          />
        </div>
        <div>
          <div className="flex justify-between items-center text-subColor5 py-4 border-b border-[#333333] cursor-pointer">
            <h4>Choose the field</h4>
            <ArrowDownSVG className="scale-125" />
          </div>
          <div className="flex justify-between items-center text-subColor5 py-4 cursor-pointer">
            <h4>List of professors</h4>
            <ArrowDownSVG className="scale-125" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeftSide;
